import $ from 'jquery';
import registerJQueryPlugin from '../lib/register-jquery-plugin';
import './slick-carousel';
import 'jquery-zoom';
import createCounter from './slick/counter';
// Expose the function as a jQuery plugin for ease of use
export const PLUGIN_NAME = 'slides';

export const SLICK_CLASS = 'js-slides-slick';
export const STATUS_CLASS = 'js-slides-status';

export const DEFAULTS = {
  slidesToShow: 1,
  showStatus: false,
  lazyLoad: 'ondemand',
  arrows: true,
  delay: 1000,
  showZoomTab: false,
  productZoomBtn: '.product-zoom__btn',
  productZoomBtnActive: 'product-zoom__btn--active',
  adjacentSlidesBorder: false, // https://revolve.atlassian.net/browse/AB-586
};

/**
 * Merges together all the options and the various conditions in which they
 * can be set.
 * @param  {jQuery} $el - slides wrap
 * @param  {Object} [options={}] - Any options provided upon initialization
 * @return {Object} Immutable version of the options
 */
const mergeOptions = ($el, options = {}) => {
    return Object.assign({}, DEFAULTS, $el.data(), options);
};

const zoomHover = ($zoomContainer, opts) => {
  const zoomImg = '.zoomImg';
  const delay = opts.delay;
  const hideClass = 'u-hide';
  let timer;
  $zoomContainer.hover(function() {
    timer = setTimeout(function() {
      $zoomContainer.find(zoomImg).removeClass(hideClass);
    }, delay);
  }, function() {
    clearTimeout(timer);
    $zoomContainer.find(zoomImg).addClass(hideClass);
  });
}

const initZoom = ($slidesWrap, opts) => {
  const $zoomContainer = $slidesWrap.find('.slick-active').find('.js-pdp-image-zoom');
  const zoomImgUrl = $zoomContainer.data('zoom-img');
  const hasActiveClass = $zoomContainer.hasClass('zoom-active');
  
  if (!hasActiveClass) {
    $zoomContainer.zoom({
      url: zoomImgUrl,
      callback: function() {
        $(this).addClass('u-hide');
      }
    });
    $zoomContainer.addClass('zoom-active');
  }
  zoomHover($zoomContainer, opts);
}

const triggerZoom = ($slidesWrap, $slides, opts) => {
  $slides
    .on('init', (event, slick, currentSlide, nextSlide) => {
      initZoom($slidesWrap, opts)
      a11yKeyboardTriggerZoom($slidesWrap);
    })
    .on('afterChange', (event, slick, currentSlide, nextSlide) => {
      initZoom($slidesWrap, opts);
      a11yKeyboardTriggerZoom($slidesWrap);
    });
}

const a11yKeyboardTriggerZoom = ($slidesWrap) => {
  $slidesWrap.find('.pdp__image').removeAttr('tabindex');
  $slidesWrap.find('.slick-active .pdp__image').attr('tabindex', '0');
}

const initSlick = ($slidesWrap, $slides, opts) => {
    if(opts.showStatus) {
      createCounter($slidesWrap);
    }
    if (!$('html').hasClass('touch') && opts.zoomImg) {
      triggerZoom($slidesWrap, $slides, opts);
    }
    if (opts.adjacentSlidesBorder) {
      outlineAdjacentSlides($slides);
    }
    $slides.slick(opts);
    if ($slides.find('video').length) {
      videoA11y($slides);
    }
}
/**
 * Adds border class to current and next slides
 */
const outlineAdjacentSlides = ($slides) => {
  const BORDER_CLASS = 'border-current';
  $slides.on('afterChange', function(event, slick, currentSlide) {
    const $mainSlickCarousel = $(slick.originalSettings.asNavFor);
    const isNotTablet = $mainSlickCarousel.slick('getSlick').activeBreakpoint == null;
    const $currentSlide = $(this).find(`.slick-slide[data-slick-index=${currentSlide}]`);
    const currentSlideCount = currentSlide + 1;
    const moreSlidesThanSlideToShow = slick.slideCount > slick.options.slidesToShow;
    const $nextSlide = currentSlideCount === slick.slideCount && !moreSlidesThanSlideToShow ? $(slick.$slides[0]) : $currentSlide.next();
    slick.$slideTrack.find('.slick-slide').removeClass(BORDER_CLASS);
    if(isNotTablet) {
      $currentSlide.addClass(BORDER_CLASS);
      $nextSlide.addClass(BORDER_CLASS);
    } else {
      $currentSlide.addClass(BORDER_CLASS);
    }
  });

  const resetPosition = (moreSlidesThanSlideToShow) => {
    $slides.on('setPosition', function(slick) {
      if(!moreSlidesThanSlideToShow) {
        $(slick.currentTarget).find('.slick-track').css({transform: `translate3d(0px, 0px, 0px)`});
      }
    });
  }

  $slides.on('init', function(event, slick, currentSlide, nextSlide) {
    const $mainSlickCarousel = $(slick.originalSettings.asNavFor);
    const isNotTablet = $mainSlickCarousel.slick('getSlick').activeBreakpoint == null;
    const $currentSlide = $(this).find('.slick-slide[data-slick-index=0]');
    const $nextSlide = $currentSlide.next();
    const moreSlidesThanSlideToShow = slick.slideCount > slick.options.slidesToShow;
    if(isNotTablet) {
      $currentSlide.addClass(BORDER_CLASS);
      $nextSlide.addClass(BORDER_CLASS);
    } else {
      $currentSlide.addClass(BORDER_CLASS);
    }
    resetPosition(moreSlidesThanSlideToShow);
  });
};
/**
  * remove active class to hide btn
  */
 const hideBtn = (opts) => {
   $(opts.productZoomBtn).removeClass(opts.productZoomBtnActive);
 }

 /**
   * add active class to show btn
   */
 const showBtn = (opts) => {
  $(opts.productZoomBtn).addClass(opts.productZoomBtnActive);
}

/**
 * Adds and removes tabindex and aria-hidden based on slide being active
 * @param {jQuery} $slides - the slides to iterate over
 */
const videoA11y = $slides => {
  $slides.find('.slick-slide').each(function() {
    const $slide = $(this);
    const $video = $slide.find('video');

    if (!$slide.hasClass('slick-active')) {
      $video.attr({
        tabIndex: '-1',
        'aria-hidden': 'true',
      });
    }
  });

  $slides.on('afterChange', (event, slick, currentSlide) => {
    $slides.find('.slick-slide').each(function() {
      const $slide = $(this);
      const $video = $slide.find('video');

      if ($slide.hasClass('slick-active')) {
        $video.attr({
          tabIndex: '0',
          'aria-hidden': 'false',
        });
      }
    });
  });
};

/**
  * show and hide button on load
  */
 const toggleProductZoomBtn = (opts) => {
  showBtn(opts);
  setTimeout(function(){
    hideBtn(opts);
 }, 1500);
}

/**
 * Initializes slides
 * @param {HTMLElement} el - tab link
 * @param {Object} [options] - Object containing override options
 */
export default function slides(el, options = {}) {
    const $slidesWrap = $(el);
    const $slides = $slidesWrap.find(`.${SLICK_CLASS}`);
    const opts = mergeOptions($slidesWrap, options);
    initSlick($slidesWrap, $slides, opts);
    if(opts.showZoomTab) {
      toggleProductZoomBtn(opts);
    }
}

registerJQueryPlugin(PLUGIN_NAME, slides);



// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/slides.js